<div class="min-h-screen">


  <div
    class="flex justify-center items-center gap-3 pt-20"
    data-aos="fade-down"
    *ngIf="viewType !== 'view'"
  >
    <!-- Search + Filter -->
    <div
      class="flex items-center w-[592px] h-[54px] rounded-[40px] overflow-hidden shadow gap-5 p-1 bg-white"
    >
      <div class="flex items-center justify-center w-12 h-12 bg-[#025590] rounded-full">
        <mat-icon class="text-white">search</mat-icon>
      </div>
      <div
        class="flex items-center justify-between flex-1 bg-gray-200 px-0 pl-3 py-0 h-[45px] rounded-[40px] gap-10"
      >
        <input
          type="text"
          placeholder="Search Warehouse"
          [(ngModel)]="searchTerm"
          class="bg-transparent outline-none flex-1 text-gray-700 font-medium"
        />
        <button
          class="flex items-center justify-center w-12 h-12 bg-[#025590] rounded-full text-white"
          (click)="onSearchIconClick()"
        >
          <img
            src="assets/images/preference-horizontal.png"
            alt="filter"
            class="h-5 w-5"
            loading="lazy"
          />
        </button>
      </div>
    </div>

    <!-- Create Button -->
    <div
      class="flex items-center bg-white text-gray-700 rounded-full p-5 h-[54px] shadow gap-3 cursor-pointer"
      (click)="onAdd()"
    >
     Add Warehouse
      <button
        class="flex items-center justify-center w-10 h-10 bg-[#025590] rounded-full text-white"
      >
        <img
          src="assets/images/add-circle-half-dot.png"
          alt="add"
          class="h-5 w-5"
          loading="lazy"
        />
      </button>
     
    </div>
  </div>

  <!-- Layout -->
  <app-shared-layout
     [Analysis]="title"
  [hideAdd]="true"
  [addPermission]="addPermission"
  addButtonName="{{ 'Create Warehouse' | titlecase }}"
  (addItem)="onAdd()"
  [smallForm]="false"
  [viewDetails]="viewDetails"
  [formTitle]="viewDetailsTitle"
  animationSize="full"
  [secondaryWithStyle]="false"
  [useBackButton]="false"
  >

    <!-- Primary Panel -->
    <div ngProjectAs="primary-panel" class="min-h-screen pt-4" data-aos="fade-up">
      <div class="flex justify-center mt-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          <div
            *ngFor="let warehouse of filteredWarehouses"
            (click)="onView(warehouse)"
            class="relative cursor-pointer transition-transform hover:scale-105 bg-white shadow-sm flex flex-col gap-3 p-5 rounded-3xl "
          >
            <!-- Card Actions -->
            <div class="flex justify-end gap-2 z-50" (click)="$event.stopPropagation()">
              <div
                class="bg-[#0255900D] p-1 shadow border border-[#025590] rounded-full w-8 h-8 flex items-center justify-center"
              >
                <button class="text-gray-600 hover:text-blue-600" (click)="onAdd(warehouse)" title="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

            <div
  class="bg-[#0255900D] p-1 shadow border border-[#025590] rounded-full w-8 h-8 flex items-center justify-center"
  *ngIf="hasPermission('can_delete_warehouse')"
>
  <button mat-icon-button color="warn" (click)="onDelete(warehouse)" title="Delete">
    <mat-icon>delete</mat-icon>
  </button>
</div>
            </div>

            <!-- Card Content -->
            <div class="border-t pt-1">
              <div class="flex items-center gap-2">
                <h2 class="!font-bold text-[#025590] text-lg uppercase">{{ warehouse?.name }}</h2>
              </div>

              <p class="text-xs text-gray-700">
                {{ warehouse?.region?.name }}/{{ warehouse?.ward?.name }}/{{ warehouse?.distric?.name }}
              </p>

              <div class="flex items-center text-xs text-gray-700 gap-2">
                <span class="font-bold">Supervisor:</span>
                <span>{{ warehouse?.supervisor }}</span>
              </div>
            </div>

            <!-- Stats -->
            <div class="flex flex-wrap gap-2 justify-between items-center text-xs text-gray-700 border-t pt-4">
              <div class="flex items-center gap-1 bg-[#8979FF17] border border-[#79a6ff] rounded-xl px-2 py-1">
                <span class="text-[#79A6FF] text-xs">Zones({{ warehouse?.zoneCount }})</span>
              </div>
              <div class="flex items-center gap-1 bg-[#33A9821C] border border-[#33a982] rounded-xl px-2 py-1">
                <span class="text-[#33A982] text-xs">Sensors({{ warehouse?.sensorCount }})</span>
              </div>
              <div class="flex items-center gap-1 bg-[#3CC3DF24] border border-[#3cc3df] rounded-xl px-2 py-1">
                <span class="text-[#3CC3DF] text-xs">Assignees({{ warehouse?.assigneeCount }})</span>
              </div>
            </div>

            <!-- Footer -->
            <div class="flex items-center text-[#005590] text-xs gap-1 mt-2">
              <img src="assets/images/circle-arrow-right-01.png" alt="arrow" loading="lazy" />
              <span class="underline">View More Details</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Secondary Panel -->
    <div ngProjectAs="secondary-panel" class="min-h-screen pt-0 flex flex-col items-start justify-start">
      <app-warehouse-view *ngIf="viewType === 'view'"></app-warehouse-view>
    </div>

  </app-shared-layout>

</div>
